export default [
  {
    path: "/mobile/attorney-document/:token",
    name: "mobile.attorney.document.upload",
    component: () => import("@/pages/frontend/attorneydocumentupload")
  }
];
